const ICU = require('i18next-icu').default || require('i18next-icu')

const { defaultLanguage, getAllLanguages } = require('./i18n/constants')

/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
    saveMissing: process.env.NODE_ENV === 'development',
    i18n: {
        defaultLocale: defaultLanguage,
        locales: getAllLanguages(),
    },
    localePath:
        typeof window === 'undefined'
            ? require('path').resolve('./public/static/locales')
            : '/static/locales',
    react: { useSuspense: false },
    trailingSlash: true,
    returnNull: false,
    serializeConfig: false,
    use: [ICU],
}
